import React from "react"
import FrontmatterPageContext from "~context/FakePageContext"
import Markdown from "markdown-to-jsx"
import mailto from "./mailto"

import data_i18n_en from "~data/i18n/en.yml"
import data_i18n_ja from "~data/i18n/ja.yml"

const T = (props) => {
  // let { lang, k } = props
  const key = props.children
  const fm = React.useContext(FrontmatterPageContext)
  const env_node = process.env.NODE_ENV

  // empty payload, show no text.
  // we can then scan for <TAG> </TAG> in source files in tests
  if (!key) {
    return <><code title="t_empty_key">{env_node === "development" ? `T[${lang || "❌"}][❓]` : ""}</code></>
  }

  let lang = props?.lang || fm?.lang || "en"

  let content

  switch (lang || "en") {
    case "en":
      content = data_i18n_en[key] || ""
      break
    case "ja":
      content = data_i18n_ja[key] || ""
      break
    default:
      // in the state lang is an actual value (but unknown to us), we can print it,
      // but if it was something else, the emoji catches it
      return (
        <code title="t_unknown_lang">{env_node === "development" ? `T[${lang || "❌"}][${key}]` : ""}</code>
      )
  }

  // catch nothings before parse, dont bother trying to md parse nothing
  // we can then scan for `unknown_key` in the output in tests
  if (content === "") {
    return (
      <code title="t_unknown_key">
        {env_node === "development" ? `T[${lang}][${key}]` : ""}
      </code>
    )
  }

  if (props?.noparse) {
    return content
  }

  return (
    <Markdown
      options={{
        overrides: {
          mailto: {
            component: mailto,
          },
        },
      }}
    >
      {content}
    </Markdown>
  )
}

export default T
